import { qs } from 'url-parse';
import execRouteMatching from './exec-route-matching';
import { matchRouteCache } from './utils';

/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */
const matchRoute = (routes, pathname, queryParams = {}, basePath = '') => {
  const queryParamObject = typeof queryParams === 'string' ? qs.parse(queryParams) : queryParams;
  const cachedMatch = matchRouteCache.get(pathname, queryParamObject, basePath);
  if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
  for (let i = 0; i < routes.length; i++) {
    const matchedRoute = execRouteMatching(routes[i], pathname, queryParamObject, basePath);
    if (matchedRoute) {
      matchRouteCache.set(pathname, queryParamObject, basePath, matchedRoute);
      return matchedRoute;
    }
  }
  return null;
};
export const matchInvariantRoute = (routes, pathname, queryParams, basePath = '') => matchRoute(routes, pathname, queryParams, basePath);

/**
 * Performance optimisation to fast-match a single route
 * instead of looping thorugh all defined routes
 */
export const warmupMatchRouteCache = (route, pathname, queryParams, basePath = '') => {
  matchRoute([route], pathname, queryParams, basePath);
};
export default ((routes, pathname, queryParams, basePath = '') => matchRoute(routes, pathname, queryParams, basePath));